<div class="password-page">
    <div class="password-wrapper">
        <mat-card class="password-card">
            <div class="password-logo-wrapper">
                <img src="/logo.png" alt="copago Logo" class="password-logo" />
            </div>

            <div class="password-header">
                <div class="header-icon">
                    <mat-icon>lock_reset</mat-icon>
                </div>

                <h1>Passwort vergessen?</h1>
                <p>
                    Geben Sie Ihre E-Mail-Adresse ein. Sie erhalten anschließend einen Link
                    zum Zurücksetzen Ihres Passworts.
                </p>
            </div>

            <form class="password-form" [formGroup]="form" (ngSubmit)="submit()">
                <div class="form-field-group">
                    <label class="custom-label" for="email">E-Mail-Adresse</label>

                    <mat-form-field appearance="outline" class="full-width custom-field">
                        <input id="email" matInput type="email" formControlName="email" placeholder="name@firma.de"
                            autocomplete="email" />
                    </mat-form-field>

                    @if (form.controls.email.touched && form.controls.email.hasError('required')) {
                    <div class="field-error">Bitte geben Sie Ihre E-Mail-Adresse ein.</div>
                    }

                    @if (form.controls.email.touched && form.controls.email.hasError('email')) {
                    <div class="field-error">Bitte geben Sie eine gültige E-Mail-Adresse ein.</div>
                    }
                </div>

                @if (serverError()) {
                <div class="server-error">
                    {{ serverError() }}
                </div>
                }

                @if (successMessage()) {
                <div class="success-message">
                    {{ successMessage() }}
                </div>
                }

                <button mat-flat-button type="submit" class="primary-button"
                    [class.cooldown-active]="isCooldownActive()" [disabled]="isSubmitting() || isCooldownActive()">
                    @if (isSubmitting()) {
                    <mat-spinner diameter="20"></mat-spinner>
                    } @else if (isCooldownActive()) {
                    <span>Erneut anfordern in {{ cooldownText() }}</span>
                    } @else {
                    <span>Link anfordern</span>
                    }
                </button>

                <a routerLink="/login" class="secondary-link">Zurück zur Anmeldung</a>
            </form>
        </mat-card>
    </div>
</div>